<div class="wrapper wrapper-content">
    <h1>Secured</h1>
<p>
    <b>User:</b> {{userInfo | json}}
</p>

</div>
